module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01#frontmatter01"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("I. AFTER SEPTEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter01#part01chapter01"
    }
  }, [_vm._v("Living Up to It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter02#part01chapter02"
    }
  }, [_vm._v("Stop Making Sense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter03#part01chapter03"
    }
  }, [_vm._v("On the Morning After Saddam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter04#part01chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Democratic World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter05#part01chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lesson of Tal Afar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter06#part01chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowing the Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter07#part01chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Betrayed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter08#part01chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Over Here")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. TROUBLE SPOTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter01#part02chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Children of Freetown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter02#part02chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Susie Bayer’s T-shirt Ended Up on Yusuf Mama’s Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter03#part02chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Images in Our Heads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter04#part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gangsta War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter05#part02chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moderate Martyr")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter06#part02chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Megacity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter07#part02chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drowning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. WRITERS AT WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter01#part03chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. S. Naipaul’s Pursuit of Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter02#part03chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Friends Like These")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter03#part03chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham Greene and the New Quiet Americans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter04#part03chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spanish Prisoner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. END OF AN ERA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter01#part04chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter02#part04chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of Conservatism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter03#part04chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hardest Vote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter04#part04chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Liberalism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0